import React from "react"
import PCMFollowUpView from "../components/PCMAdmin/PCMFollowUp/PCMFollowUpView"

const PCMFollowUp = () => <PCMFollowUpView />

export default PCMFollowUp
